import React from 'react'

const QuestionIcon = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <defs />
      <path
        fill={color}
        d="M224 1.5C131 13 51.9 74.6 17 162.6c-7.3 18.2-13.8 45-16 65.6-1.3 12.5-1.3 43.1 0 55.6C11 378.2 73.2 459.5 162.6 495c18.2 7.3 45 13.8 65.6 16 12.5 1.3 43.1 1.3 55.6 0 101.6-10.8 187.9-82.3 217.6-180.4 7.4-24.3 10.6-46.8 10.6-74.6 0-20.9-1-32.4-4.6-50.5-16.8-85.2-76.1-156-158-188.5-18.2-7.3-45-13.8-65.6-16-13.1-1.4-46.9-1.1-59.8.5zm45 127.9c33.2 5.5 55 26.7 55 53.7 0 19.2-11.9 39.5-34.7 58.7-17.4 14.7-20.1 19.5-21.4 37.6-.9 13-1.9 15.5-7.2 18.3-4.9 2.5-18.2 2.9-22.7.6-5.9-3-7.5-7.8-7.4-21.3.1-23.9 7.1-37.6 27.6-54.2 19-15.3 24-22.3 24.1-33.7.1-15.2-10.7-23.3-31.3-23.3-15.3 0-21.1 3-30.4 15.6-6.1 8.3-9.3 10.1-16.6 9.4-10.7-1.1-17.9-9.9-16.6-20.5 2.3-19.6 23.9-37.4 50.1-41.2 9.4-1.3 22.2-1.2 31.5.3zm-9.1 198c4 2.1 8.8 7.1 11.1 11.6 3 5.8 3.4 11 1.6 17.4-4 13.7-18.3 21.5-31.8 17.4-5.3-1.6-13.2-8.8-15.3-14-4.8-11.8.5-26.6 11.7-32.4 6.5-3.4 16.1-3.4 22.7 0z"
      />
    </svg>
  )
}

QuestionIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default QuestionIcon
